module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard.8db8180d.svg";